import { ContextMenuOption } from "../../../models/context-menu-option";
import { EntityType } from "../../../models/enums";
import { NavigationInfo } from "../../../models/navigation-info";
import { ObjectActionListType, PermissionSet } from "../../../models/permission";
import { GenericTreeNode } from "../../generic-tree/generic-tree-node";

export const DiscardPileMenu = new GenericTreeNode({
    name: 'Discard Pile',
    entityType: EntityType.discardPile,
    automationId: 'nav-tree-discard-pile',
    icon: 'fa-recycle',
    iconColor: 'color-grey-10',
    isExpandable: false,
    customClasses: 'node-left-margin',
    permissions: [new PermissionSet({ permissionType: ObjectActionListType.DISCARD_PILE })],
    navigationInfo: new NavigationInfo(
        { name: 'All Docs', path: 'document-list', default: true }),
    showContextMenuButton: true,
    contextMenuOptions: Array<ContextMenuOption>(
        new ContextMenuOption({
            name: 'Discard Pile Log ...', 
            iconSecondClass: 'fa-history', 
            iconSecondColor: 'color-blue-01',
            iconClass: 'fa-recycle', 
            iconColor: 'color-grey-16'
        }),
    )
});